import format from 'date-fns/format'


export function createDateFromString(dateString) {
    const [year, month, date] = dateString.split('-')

    if (!year || !month || !date)
        return null

    return new Date(year, Number(month) - 1, date)
}

export function createDateFromObject(dateObject) {
    if (!dateObject)
        return null

    return new Date(dateObject.year, dateObject.month)
}


export function getDateFirstMonth(year) {
    if (!year)
        return null

    return new Date(year, 0, 1)
}

export function getDateLastMonth(year) {
    if (!year)
        return null

    return new Date(year, 12, 0)
}

export function getLastDayFromMonth(date) {
    if (!date)
        return null

    return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export function formatDateFromDate(date, stringFormat = 'dd/MM/yyyy') {
    if (!date)
        return ''

    return format(date, stringFormat)
}

export function formatDate(date, stringFormat = 'dd/MM/yyyy') {
    if (!date)
        return ''

    return format(date, stringFormat)
}
